import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";
import Logo from "@/components/Logo";

export default function NotFound() {
  return (
    <div className="hero-radial relative flex min-h-screen flex-col items-center justify-center bg-void px-6" data-testid="not-found-page">
      <Seo title="Page Not Found | LogiTech Nexus" siteName="LogiTech Nexus" description="The page you're looking for doesn't exist." />
      <div className="bg-grid absolute inset-0 [mask-image:radial-gradient(ellipse_at_center,black_20%,transparent_70%)]" />
      <div className="relative text-center">
        <Logo />
        <p className="mt-12 font-mono text-7xl font-semibold text-slate-800">404</p>
        <h1 className="mt-4 font-display text-2xl font-semibold text-white sm:text-3xl">
          This node isn't connected yet.
        </h1>
        <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-slate-400">
          The page you're looking for doesn't exist or may have been moved.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-blue-600 px-6 py-3 text-sm font-semibold text-white transition-[background-color,transform] duration-300 hover:bg-blue-500 active:scale-[0.98]"
        >
          <ArrowLeft size={15} />
          Back to Home
        </Link>
      </div>
    </div>
  );
}
